import {graphql} from 'react-apollo';

import {SUBMIT_TIMESHEET_MUTATION, TIMESHEET_DETAIL_QUERY} from '../../queries';
import {buildTsInput} from '../../../shared/utils/queries';

export default graphql(SUBMIT_TIMESHEET_MUTATION, {
  props: ({
    ownProps: {
      timesheet,
      setLoading,
      setError,
      setSuccess,
      clearLoading,
      client,
      date,
      timesheetUser
    },
    mutate
  }) => ({
    submitTimesheet(selectedDates) {
      const dates = timesheet.totals
        .map(x => x.Date.format('YYYY-MM-DD'))
        .filter(x => selectedDates.includes(x));

      if (!dates.length) {
        return setError('There are no days which can be submitted.');
      }

      setLoading();

      const detailVars = {date, timesheetUser};

      return mutate({
        variables: {
          ...buildTsInput(timesheet),
          dates
        },
        update(store, {data}) {
          const nextTs = data && data.submitTimesheet;
          if (!nextTs) return;
          try {
            store.readQuery({query: TIMESHEET_DETAIL_QUERY, variables: detailVars});
            store.writeQuery({
              query: TIMESHEET_DETAIL_QUERY,
              variables: detailVars,
              data: {timesheet: nextTs}
            });
          } catch (e) {
            if (client) {
              client
                .query({
                  query: TIMESHEET_DETAIL_QUERY,
                  variables: detailVars,
                  fetchPolicy: 'network-only'
                })
                .catch(() => {});
            }
          }
        }
      })
        .then(
          () => {
            setSuccess('Timesheet has been submitted');
          },
          e => setError(e)
        )
        .then(clearLoading);
    }
  })
});
